import gameiomModel from "gameiom/model/gameiom-model";
import Gameplay from "slotworks/model/gameplay/gameplay";
import AuthRequestPayload from "slotworks/model/gameplay/requests/auth-request-payload";
import settingsModel, { RealityMode } from "slotworks/model/settings/settings-model";
import { RequestBuilder } from "slotworks/server/builders/request-builder";
import { SocketRequest } from "slotworks/server/connectors/socket-connector";

class AuthRequestBuilder implements RequestBuilder {
    public filter(request: any): boolean {
        return request instanceof AuthRequestPayload;
    }
    public build(gameplay: Gameplay, request: any) {

        const body = {
            platform: {
                sessionToken: gameiomModel.sessionToken,
                username: gameiomModel.username,
                providerId: gameiomModel.providerId,
                operatorId: gameiomModel.operatorId,
                gameId: gameiomModel.gameId
            },
            publicState: {
                action: "init",
                userName: gameiomModel.username,
                gameId: gameiomModel.gameId,
                mode: settingsModel.playMode === RealityMode.REAL ? "realPlay" : "freePlay",
                jurisdiction: gameiomModel.jurisdiction
            }
        };

        return new SocketRequest(body, gameiomModel.url);
    }
}

export default new AuthRequestBuilder();
